// assets/card-size-select.js — hard-block PDP navigation when clicking <select.size-select>
document.addEventListener('DOMContentLoaded', () => {
  // 1) <select.size-select> 経由のクリックは、どの親<a>でもナビを止める
  document.addEventListener('click', (e) => {
    const path = (typeof e.composedPath === 'function') ? e.composedPath() : null;
    const fromSizeSelect = path
      ? path.some((n) => n && n.nodeType === 1 && n.classList && n.classList.contains('size-select'))
      : !!e.target.closest('.size-select');

    if (fromSizeSelect) {
      // クリックからのアンカー遷移を確実に抑止
      e.preventDefault();
      if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();
      e.stopPropagation();
      return false;
    }
  }, false);

  // 2) サイズ変更で価格・画像・リンクを更新（カラーJSと同等の流儀）
  document.addEventListener('change', (e) => {
    const select = e.target.closest('.size-select');
    if (!select) return;

    const currentCard = select.closest('.grid-product');
    if (!currentCard) return;

    const opt = select.selectedOptions && select.selectedOptions[0];
    if (!opt) return;

    // 価格
    const priceEl   = currentCard.querySelector('.js-card-price-current');
    const compareEl = currentCard.querySelector('.js-card-price-compare');
    const price     = toNum(opt.dataset.price);
    const compare   = toNum(opt.dataset.compare);

    if (priceEl) priceEl.textContent = formatYen(price);
    if (compareEl) {
      if (Number.isFinite(compare) && compare > price) {
        compareEl.textContent = formatYen(compare);
        compareEl.style.display = '';
      } else {
        compareEl.style.display = 'none';
      }
    }
    // 画像
    const newImageUrl = opt.dataset.image;
    const imgMain = currentCard.querySelector('.grid-product__image-mask img');
    if (imgMain && newImageUrl) {
      imgMain.src = newImageUrl;
      imgMain.srcset = newImageUrl;
    }

    // リンク先（?variant=）更新
    const mainLink = currentCard.querySelector('.grid-product__link');
    if (mainLink) {
      const baseUrl = mainLink.href.split('?')[0];
      mainLink.href = `${baseUrl}?variant=${opt.value}`;
    }
  });

  // helpers
  function toNum(v){ if(v===undefined||v===null||v==='') return NaN; const n=Number(v); return Number.isNaN(n)?NaN:n; }
  function formatYen(n){ if(!Number.isFinite(n)) return ''; try{ return '￥'+Math.round(n).toLocaleString('ja-JP'); } catch { return '￥'+Math.round(n); } }
});